import { PopoverTrigger } from '@spotify-internal/encore-web';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useCustomer } from 'utils/user';
import { MastheadLinkOrLinkListArray } from 'lib/sanity/types';
import { MOBILE_NAVIGATION_BREAKPOINT } from 'components/Masthead/Header/types';
import { NavBarAvatar } from 'components/Masthead/Header/Profile/Avatar';
import { useUbiMastheadHeader } from 'utils/ubi/pages/useUbiHeader';
import { ProfileLinksPopoverNavigation } from 'components/Masthead/Header/Profile/PopoverNavigation';

const StyledButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
`;

type Props = {
  profileLinks?: MastheadLinkOrLinkListArray;
};

export const ProfileLinksPopoverTrigger = ({ profileLinks }: Props) => {
  // needs to be vertical friendly
  const { isFetching, user } = useCustomer();
  const [isOpen, setIsOpen] = useState(false);
  const ubi = useUbiMastheadHeader();

  const isLoggedIn = user !== null;

  const toggle = () => {
    if (!isFetching) {
      ubi.logAvatarInteraction(!isOpen);
      setIsOpen(!isOpen);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= MOBILE_NAVIGATION_BREAKPOINT) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      window.addEventListener('resize', handleResize, false);
    } else {
      window.removeEventListener('resize', handleResize, false);
    }
  }, [isOpen]);

  return (
    <PopoverTrigger
      onShow={() => {}}
      onHide={() => {}}
      placement={PopoverTrigger.bottomLeft}
      overlay={
        isOpen && profileLinks ? (
          <ProfileLinksPopoverNavigation isLoggedIn={isLoggedIn} profileLinks={profileLinks} ubi={ubi} />
        ) : null
      }
    >
      <StyledButton onClick={toggle}>
        <NavBarAvatar loading={isFetching} src={user?.images?.[0]?.url || ''} />
      </StyledButton>
    </PopoverTrigger>
  );
};
